import { _values, tsValidate_OptionalArray, tsValidateNumber, tsValidateString, tsValidateUniqueId, tsValidateValue, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
import { SmartDocsType_Enum } from './consts.js';
import { AdvisorRuntimeIDBGroup, Validator_EncounterId } from '../_core/index.js';
const Validator_ModifiableProps = {
    ...Validator_EncounterId,
    smartDocType: tsValidateValue(_values(SmartDocsType_Enum)),
    templateId: tsValidateUniqueId,
    smartLogRefId: tsValidateString(undefined, false),
    text: {
        title: tsValidateString(),
        body: tsValidateString(),
    },
    timeCreated: tsValidateNumber(),
    comments: tsValidate_OptionalArray(tsValidateString())
};
const Validator_GeneratedProps = {
    _auditorId: tsValidator_nonMandatoryString,
};
export const DBDef_RuntimeSmartDoc = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'runtime-smart-docs',
    entityName: 'RuntimeSmartDoc',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'runtime-smart-docs'
    },
    backend: {
        name: 'runtime-smart-docs'
    }
};
//# sourceMappingURL=db-def.js.map